/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/



/*INÍCIO CÓDIGO PARA MOSTRAR COMBINACAO DE CAPA COM REFIL NO CARRINHO*/

(function () {
  /*
   * Tipos de produto considerados miolos.
   */
  var TIPOS_MIOLO = [
    'Refil',
    'Planner',
    'Caderno',
    'Divisória'
  ];

  var OPCAO_SEPARADA =
    'Enviar separadamente, fora da capa';

  var PREFIXO_COMBINACAO =
    'Combinar com - unidade ';

  var processandoCarrinho = false;

  /*
   * Propriedades do Aris exibidas na identificação.
   */
  var OPCOES_EXIBIDAS = [
    {
      rotulo: 'Tamanho',
      nomes: [
        'Tamanho',
        'Tamanho do Caderno'
      ]
    },
    {
      rotulo: 'Papel',
      nomes: ['Papel']
    },
    {
      rotulo: 'Quantidade de folhas',
      prefixo: 'Quant. Folhas'
    }
  ];

  document.addEventListener(
    'DOMContentLoaded',
    function () {
      carregarCarrinho();
    }
  );

  /*
   * Atualiza a área quando o tema informa
   * que houve alguma alteração no carrinho.
   */
  document.addEventListener(
    'theme:cart:change',
    function (event) {
      if (processandoCarrinho) return;

      if (event.detail && event.detail.cart) {
        prepararCarrinho(event.detail.cart);
      } else {
        carregarCarrinho();
      }
    }
  );

  function carregarCarrinho() {
    if (processandoCarrinho) return;

    fetch('/cart.js')
      .then(function (response) {
        if (!response.ok) {
          throw new Error(
            'Não foi possível carregar o carrinho.'
          );
        }

        return response.json();
      })
      .then(prepararCarrinho)
      .catch(function (error) {
        console.error(
          'Erro ao carregar o carrinho:',
          error
        );

        processandoCarrinho = false;
      });
  }

  function ehMiolo(item) {
    return (
      TIPOS_MIOLO.indexOf(item.product_type) !== -1
    );
  }

  /*
   * Cria uma propriedade de combinação para cada unidade
   * antes de montar a interface.
   */
  function prepararCarrinho(cart) {
    if (processandoCarrinho) return;

    processandoCarrinho = true;

    normalizarCombinacoes(cart)
      .then(function (carrinhoAtualizado) {
        renderPairing(carrinhoAtualizado);
      })
      .catch(function (error) {
        console.error(
          'Erro ao preparar as combinações:',
          error
        );

        renderPairing(cart);
      })
      .finally(function () {
        processandoCarrinho = false;
      });
  }

  /*
   * Localiza o primeiro miolo que precisa ter propriedades
   * criadas, migradas ou removidas.
   */
  function encontrarAjusteDeCombinacao(cart) {
    var miolos = cart.items.filter(ehMiolo);

    for (var i = 0; i < miolos.length; i++) {
      var miolo = miolos[i];

      var propriedades = Object.assign(
        {},
        miolo.properties || {}
      );

      var alterado = false;

      var combinacaoAntiga =
        propriedades['Combinar com'] || '';

      /*
       * Cria uma propriedade para cada unidade.
       */
      for (
        var unidade = 1;
        unidade <= miolo.quantity;
        unidade++
      ) {
        var nomePropriedade =
          PREFIXO_COMBINACAO + unidade;

        if (!propriedades[nomePropriedade]) {
          propriedades[nomePropriedade] =
            unidade === 1 && combinacaoAntiga
              ? combinacaoAntiga
              : OPCAO_SEPARADA;

          alterado = true;
        }
      }

      /*
       * Migra a propriedade usada pelo código anterior.
       */
      if (
        Object.prototype.hasOwnProperty.call(
          propriedades,
          'Combinar com'
        )
      ) {
        delete propriedades['Combinar com'];
        alterado = true;
      }

      /*
       * Remove combinações excedentes caso a cliente
       * diminua a quantidade do produto.
       */
      Object.keys(propriedades).forEach(
        function (nome) {
          if (
            nome.indexOf(PREFIXO_COMBINACAO) !== 0
          ) {
            return;
          }

          var numeroUnidade = parseInt(
            nome.replace(PREFIXO_COMBINACAO, ''),
            10
          );

          if (
            !isNaN(numeroUnidade) &&
            numeroUnidade > miolo.quantity
          ) {
            delete propriedades[nome];
            alterado = true;
          }
        }
      );

      if (alterado) {
        return {
          key: miolo.key,
          quantity: miolo.quantity,
          properties: propriedades
        };
      }
    }

    return null;
  }
  

  /*
   * Atualiza um item de cada vez, pois a chave do item
   * pode mudar quando suas propriedades são alteradas.
   */
  function normalizarCombinacoes(cart) {
    var ajuste = encontrarAjusteDeCombinacao(cart);

    if (!ajuste) {
      return Promise.resolve(cart);
    }

    return fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
  id: ajuste.key,
  quantity: ajuste.quantity,
  properties: ajuste.properties
})
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error(
            'Não foi possível preparar as unidades.'
          );
        }

        return response.json();
      })
      .then(function (carrinhoAtualizado) {
        return normalizarCombinacoes(
          carrinhoAtualizado
        );
      });
  }

  /*
   * Limpa somente o texto mostrado na área de combinação.
   * As propriedades originais do Aris não são modificadas.
   */
  function limparValorOpcao(valor) {
    var texto = String(valor || '').trim();

    /*
     * 50 fls / R$31 [ R$ 19,00 ]
     *
     * transforma-se em:
     *
     * 50 fls
     */
    if (/^\d+\s*fls?\b/i.test(texto)) {
      texto = texto
        .split(/\s*\/\s*R\$/i)[0]
        .trim();
    }

    /*
     * Remove preços no final das opções:
     *
     * Pocket (8x12) [ R$ 6,00 ]
     * transforma-se em:
     * Pocket (8x12)
     */
    texto = texto.replace(
      /\s*\[\s*R\$\s*[\d.,]+\s*\]\s*$/i,
      ''
    );

    return texto.trim();
  }

  /*
   * Obtém as propriedades do Aris que serão exibidas.
   */
  function getOpcoesDoAris(item) {
    var propriedades = item.properties || {};
    var resultado = [];

    OPCOES_EXIBIDAS.forEach(
      function (configuracao) {
        var nomeEncontrado = null;
        var valorEncontrado = null;

        /*
         * Procura por nomes exatos.
         */
        if (configuracao.nomes) {
          configuracao.nomes.some(
            function (nome) {
              var valor = propriedades[nome];

              if (
                valor !== undefined &&
                valor !== null &&
                String(valor).trim() !== ''
              ) {
                nomeEncontrado = nome;
                valorEncontrado = valor;
                return true;
              }

              return false;
            }
          );
        }

        /*
         * Procura propriedades que começam
         * com determinado texto.
         */
        if (
          !nomeEncontrado &&
          configuracao.prefixo
        ) {
          nomeEncontrado = Object.keys(
            propriedades
          ).find(function (nome) {
            var valor = propriedades[nome];

            return (
              nome.indexOf(
                configuracao.prefixo
              ) === 0 &&
              valor !== undefined &&
              valor !== null &&
              String(valor).trim() !== ''
            );
          });

          if (nomeEncontrado) {
            valorEncontrado =
              propriedades[nomeEncontrado];
          }
        }

        if (nomeEncontrado) {
          resultado.push({
            nome: configuracao.rotulo,
            valor: limparValorOpcao(
              valorEncontrado
            )
          });
        }
      }
    );

    return resultado;
  }

  /*
   * Obtém e junta as duas partes
   * da personalização da capa.
   */
  function getNomePersonalizadoDaCapa(item) {
    var propriedades = item.properties || {};

    var primeiraParte = limparValorOpcao(
      propriedades[
        'Digite até 12 caracteres'
      ] || ''
    );

    var complemento = limparValorOpcao(
      propriedades[
        'Gostaria de completar a personalização anterior?'
      ] || ''
    );

    return [primeiraParte, complemento]
      .filter(function (parte) {
        return parte !== '';
      })
      .join(' ');
  }

  /*
   * Gera o resumo das opções do miolo.
   */
  function getResumoOpcoes(item) {
    return getOpcoesDoAris(item)
      .map(function (opcao) {
        return (
          opcao.nome + ': ' + opcao.valor
        );
      })
      .filter(Boolean)
      .join(' · ');
  }

  /*
   * Cria a identificação completa da capa.
   */
  function getIdentificacaoCompleta(item) {
    var partes = [item.product_title];

    /*
     * Compatibilidade com variantes nativas da Shopify.
     */
    if (
      item.variant_title &&
      item.variant_title !== 'Default Title'
    ) {
      partes.push(item.variant_title);
    }

    /*
     * Inclui tamanho e outras opções configuradas.
     */
    var opcoes = getOpcoesDoAris(item);

    opcoes.forEach(function (opcao) {
      partes.push(
        opcao.nome + ': ' + opcao.valor
      );
    });

    /*
     * Inclui o nome personalizado da capa.
     */
    var nomePersonalizado =
      getNomePersonalizadoDaCapa(item);

    if (nomePersonalizado) {
      partes.push(
        'Nome: ' + nomePersonalizado
      );
    }

    return partes.join(' · ');
  }

  /*
   * Monta a área de combinação de capas e miolos.
   */
  function renderPairing(cart) {
    var container = document.getElementById(
      'pairing-container'
    );

    if (!container) return;

    var capas = cart.items.filter(
      function (item) {
        return item.product_type === 'Capa';
      }
    );

    var miolos = cart.items.filter(ehMiolo);

    container.innerHTML = '';

    /*
     * Esconde a área se não houver pelo menos
     * uma capa e um miolo no carrinho.
     */
    if (
      capas.length === 0 ||
      miolos.length === 0
    ) {
      container.style.display = 'none';
      return;
    }

    container.style.display = '';

    /*
     * Título.
     */
    var titulo = document.createElement('p');
    titulo.className = 'pairing-title';
    titulo.textContent =
      'Receba os refis dentro das capas';

    container.appendChild(titulo);

    /*
     * Explicação para a cliente.
     */
    var explicacao =
      document.createElement('p');

    explicacao.className =
      'pairing-description';

    explicacao.textContent =
      'Escolha em qual capa cada refil deverá ser colocado. ' +
      'Caso a capa não consiga comportar todos os refis selecionados, ' +
      'o excedente será enviado separadamente. ' +
      'Se preferir recebê-lo fora das capas, selecione a opção ' +
      'de envio separado.';

    container.appendChild(explicacao);

    /*
     * Cria uma linha para cada unidade de cada miolo.
     * O produto continua agrupado no carrinho da Shopify.
     */
    miolos.forEach(function (miolo) {
      var propriedades =
        miolo.properties || {};

      for (
        var unidade = 1;
        unidade <= miolo.quantity;
        unidade++
      ) {
        criarLinhaDeCombinacao(
          container,
          miolo,
          unidade,
          capas,
          propriedades
        );
      }
    });

    /*
     * Monitora alterações nas listas.
     */
    container
      .querySelectorAll('.pairing-select')
      .forEach(function (select) {
        select.addEventListener(
          'change',
          function (event) {
            atualizarCombinacao(
              event.target
            );
          }
        );
      });
  }

  /*
   * Cria uma linha de combinação
   * para uma unidade do miolo.
   */
  function criarLinhaDeCombinacao(
    container,
    miolo,
    unidade,
    capas,
    propriedades
  ) {
    var nomePropriedade =
      PREFIXO_COMBINACAO + unidade;

    var combinacaoAtual =
      propriedades[nomePropriedade] ||
      OPCAO_SEPARADA;

    var row = document.createElement('div');
    row.className = 'pairing-row';

    /*
     * Informações do miolo.
     */
    var productInfo =
      document.createElement('div');

    productInfo.className =
      'pairing-product';

    var productName =
      document.createElement('span');

    productName.className =
      'pairing-product-name';

    /*
     * Só mostra o número da unidade
     * quando há mais de uma unidade.
     */
    if (miolo.quantity > 1) {
      productName.textContent =
        miolo.product_title +
        ' · unidade ' +
        unidade;
    } else {
      productName.textContent =
        miolo.product_title;
    }

    productInfo.appendChild(productName);

    /*
     * Tamanho, papel e quantidade de folhas.
     */
    var resumoMiolo =
      getResumoOpcoes(miolo);

    if (resumoMiolo) {
      var optionSummary =
        document.createElement('span');

      optionSummary.className =
        'pairing-variant';

      optionSummary.textContent =
        resumoMiolo;

      productInfo.appendChild(
        optionSummary
      );
    }

    /*
     * Texto entre o miolo e a lista de capas.
     */
    var connector =
      document.createElement('span');

    connector.className =
      'pairing-connector';

    connector.textContent =
      'combinar com:';

    /*
     * Cria a lista de capas.
     */
    var select =
      document.createElement('select');

    select.className = 'pairing-select';
    select.dataset.key = miolo.key;

    /*
     * Identifica qual unidade será modificada.
     */
    select.dataset.propertyName =
      nomePropriedade;

    /*
     * Opção para receber o miolo fora das capas.
     */
    var looseOption =
      document.createElement('option');

    looseOption.value =
      OPCAO_SEPARADA;

    looseOption.textContent =
      OPCAO_SEPARADA;

    if (
      combinacaoAtual ===
      OPCAO_SEPARADA
    ) {
      looseOption.selected = true;
    }

    select.appendChild(looseOption);

    /*
     * Adiciona as capas presentes no carrinho.
     */
    capas.forEach(function (capa) {
      var identificacaoCapa =
        getIdentificacaoCompleta(capa);

      var option =
        document.createElement('option');

      option.value =
        identificacaoCapa;

      option.textContent =
        identificacaoCapa;

      if (
        combinacaoAtual ===
        identificacaoCapa
      ) {
        option.selected = true;
      }

      select.appendChild(option);
    });

    row.appendChild(productInfo);
    row.appendChild(connector);
    row.appendChild(select);

    container.appendChild(row);
  }

  /*
   * Salva a combinação nas propriedades do miolo.
   */
  function atualizarCombinacao(select) {
    var selectedValue = select.value;

    var propertyName =
      select.dataset.propertyName;

    select.disabled = true;

    select.classList.add(
      'is-loading'
    );

    /*
     * Busca novamente o carrinho antes de salvar.
     * Isso garante que as propriedades mais recentes
     * do Aris sejam preservadas.
     */
    fetch('/cart.js')
      .then(function (response) {
        if (!response.ok) {
          throw new Error(
            'Não foi possível carregar o carrinho.'
          );
        }

        return response.json();
      })
      .then(function (cart) {
        var item = cart.items.find(
          function (cartItem) {
            return (
              cartItem.key ===
              select.dataset.key
            );
          }
        );

        if (!item) {
          throw new Error(
            'O miolo não foi encontrado no carrinho.'
          );
        }

        /*
         * Copia todas as propriedades existentes.
         *
         * Isso preserva:
         * - Tamanho;
         * - Papel;
         * - Quantidade de folhas;
         * - propriedades internas do Aris;
         * - acréscimos e personalizações;
         * - combinações das outras unidades.
         */
        var propriedades = Object.assign(
          {},
          item.properties || {}
        );

        /*
         * Altera somente a unidade selecionada.
         */
        propriedades[propertyName] =
          selectedValue;

        return fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type':
              'application/json'
          },
          body: JSON.stringify({
  id: select.dataset.key,
  quantity: item.quantity,
  properties: propriedades
})
        });
      })
      .then(function (response) {
        if (!response.ok) {
          throw new Error(
            'Não foi possível salvar a forma de montagem.'
          );
        }

        return response.json();
      })
      .then(function () {
        window.location.reload();
      })
      .catch(function (error) {
        console.error(
          'Erro ao salvar a forma de montagem:',
          error
        );

        select.disabled = false;

        select.classList.remove(
          'is-loading'
        );

        alert(
          'Não foi possível salvar a forma de montagem. ' +
          'Tente novamente.'
        );
      });
  }
})();

/*FIM DO CÓDIGO PARA MOSTRAR COMBINACAO DE CAPA COM REFIL NO CARRINHO*/






(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();
